import React from "react";
import RubricEntryForm from "../RubricsMarking/form";
import FacultyDashboardLayout from "./FacultyDashboardLayout";

const RubricsMarking = () => {
  return (
    <FacultyDashboardLayout>
      <RubricEntryForm />
    </FacultyDashboardLayout>
  );
};

export default RubricsMarking;
